import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-382ddeec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "case" }
const _hoisted_4 = { class: "case" }
const _hoisted_5 = { class: "case" }
const _hoisted_6 = { class: "case" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-tablet" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-plus" }, null, -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "viewAll-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-tablet" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View All", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_case = _resolveComponent("item-case")!
  const _component_app_skeleton_case = _resolveComponent("app-skeleton-case")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!

  return (_ctx.cases.length || _ctx.dataLoading || _ctx.skeleton || _ctx.showCreateCaseBtn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_item_wrapper, null, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          control: _withCtx(() => [
            _createElementVNode("span", {
              class: "black-link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewAllCases && _ctx.viewAllCases(...args)))
            }, _toDisplayString(_ctx.$localize('drive.section.button.view_all')), 1)
          ]),
          main: _withCtx(() => [
            (_ctx.mainStore.isMobile)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["case-wrapper", {'jc-start': _ctx.cases.length < 3}]),
                  ref: "scroller",
                  onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
                }, [
                  (!_ctx.dataLoading && !_ctx.skeleton)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.cases, (iCase) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: iCase.id!,
                          class: "case",
                          onClick: ($event: any) => (_ctx.onCaseClick(iCase))
                        }, [
                          _createVNode(_component_item_case, { iCase: iCase }, null, 8, ["iCase"])
                        ], 8, _hoisted_2))
                      }), 128))
                    : _createCommentVNode("", true),
                  (_ctx.dataLoading || _ctx.isPageLoading || _ctx.skeleton)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_app_skeleton_case)
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_app_skeleton_case)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_app_skeleton_case)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_app_skeleton_case)
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.cases.length >= 27)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "viewAll",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewAllCases && _ctx.viewAllCases(...args)))
                      }, [
                        _hoisted_7,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$localize('drive.section.button.view_all')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showCreateCaseBtn)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: "create-case-btn",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.createCase && _ctx.createCase(...args)))
                      }, [
                        _hoisted_8,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$localize('drive.section.button.add_case')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 34))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_swiper, {
                    class: "case-wrapper d-slider",
                    "slides-per-view": 8,
                    "space-between": 12
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.dataLoading)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.cases, (iCase) => {
                            return (_openBlock(), _createBlock(_component_swiper_slide, {
                              key: iCase.id!,
                              class: "case d-slider__slide"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_item_case, {
                                  onClick: ($event: any) => (_ctx.onCaseClick(iCase)),
                                  iCase: iCase
                                }, null, 8, ["onClick", "iCase"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        : _createCommentVNode("", true),
                      (_ctx.dataLoading || _ctx.isPageLoading)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(18, (n) => {
                            return _createVNode(_component_swiper_slide, {
                              class: "case d-slider__slide",
                              key: n
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_app_skeleton_case)
                              ]),
                              _: 2
                            }, 1024)
                          }), 64))
                        : _createCommentVNode("", true),
                      (_ctx.cases.length >= 27)
                        ? (_openBlock(), _createBlock(_component_swiper_slide, {
                            key: 2,
                            class: "d-slider__slide"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", {
                                  class: "viewAll",
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.viewAllCases && _ctx.viewAllCases(...args)))
                                }, _hoisted_13)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}